// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { fantomTestnet as _fantomTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the fantomTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 4002
 * Chain Name: Fantom Testnet
 * Default Block Explorer: https://testnet.ftmscan.com
 * Default RPC URL: https://rpc.testnet.fantom.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { fantomTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: fantomTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const fantomTestnet = createCommon({
	..._fantomTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
